export let ToastViewportCssVars = /*#__PURE__*/function (ToastViewportCssVars) {
  /**
   * Indicates the height of the frontmost toast.
   * @type {number}
   */
  ToastViewportCssVars["frontmostHeight"] = "--toast-frontmost-height";
  return ToastViewportCssVars;
}({});